import moment from "moment";
import { DATE_FORMAT_FOR_API } from "../deadlines/shared";

/** Funzione per calcolare la data di partenza */
export const getFromDate = customersView => {
  let fromDate;

  if (localStorage.getItem("calendarFromDate") && customersView) {
    fromDate = localStorage.getItem("calendarFromDate");
  }
  if (!fromDate) {
    // Set first and last day of month

    const date = new Date(moment().format(DATE_FORMAT_FOR_API)),
      y = date.getFullYear(),
      m = date.getMonth();

    const firstDay = new Date(
      y, m, 1
    );
    const tzoffset = new Date(firstDay).getTimezoneOffset() * 60000;
    fromDate = new Date(firstDay - tzoffset).toISOString().split("T")[0];
  }
  return fromDate;
};

/** Funzione per calcolare la data di termine */
export const getToDate = customersView => {
  let toDate;

  if (localStorage.getItem("calendarToDate") && customersView) {
    toDate = localStorage.getItem("calendarToDate");
  }

  if (!toDate) {
    // Set first and last day of month
    const tzoffset = new Date().getTimezoneOffset() * 60000;
    const date = new Date(moment().format(DATE_FORMAT_FOR_API)),
      y = date.getFullYear(),
      m = date.getMonth();

    const lastDay = !customersView
      ? new Date(
        y, 11, 31
      )
      : new Date(
        y, m + 1, 0
      );

    toDate = new Date(lastDay - tzoffset).toISOString().split("T")[0];
  }

  return toDate;
};
